<template>
  <div id="index">
    <tl-header v-if="topShow"></tl-header>
    <router-view></router-view>
    <tl-footer v-if="footShow"></tl-footer>
    <div class="advice-logo" @click="showAdvice"></div>
    <tl-advice :adviceBl="adviceBl" @close="closedia"></tl-advice>
    <div class="connection-bars" v-if="connectShow">
      <p>王经理</p>
      <p>138 1146 7965</p>
      <p>wangzhihui@uzoo.cn</p>
    </div>
  </div>
</template>

<script>
import TlHeader from '@/components/head/banner-top'
import TlFooter from '@/components/footer'
import TlAdvice from '@/components/advice'
export default {
  components: {
    TlHeader,
    TlFooter,
    TlAdvice
  },
  data () {
    return {
      adviceBl: false
    }
  },
  computed: {
    topShow () {
      return this.$store.state.Home.topbarShow
    },
    footShow () {
      return this.$store.state.Home.footbarShow
    },
    connectShow () {
      return this.$store.state.Home.conShow
    }
  },
  methods: {
    showAdvice () {
      this.adviceBl = !this.adviceBl
      if (window._czc) {
        window._czc.push(['_trackEvent', '悬浮框', '点击', '意见反馈-图宝', '1', '意见反馈-图宝'])
      }
    },
    closedia () {
      this.adviceBl = false
    }
  }
}
</script>
<style lang="less">
  body::-webkit-scrollbar {display:none}
  #index {
    .advice-logo {
      position: fixed;
      right: 30px;
      bottom: 70px;
      width: 92px;
      height: 110px;
      background: url(../assets/images/advice.png) no-repeat;
      z-index: 99;
      cursor: pointer;
    }
    .connection-bars {
      position: fixed;
      right: 30px;
      bottom: 150px;
      p {
        font-size: 14px;
        line-height: 24px;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue